import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { useIconSwapService } from './IconSwapService.jsx';
import { round, convertHexToDecimal } from '../utils/Conversions.js';
import { renderIcon } from '../utils/ShowIcons';

import SortArrow from '../images/sortArrow.png';
import SortedUp from '../images/sortedUp.png';
import SortedDown from '../images/sortedDown.png';

const swapTypes = {
  AC3: 'cx9ab3078e72c8d9017194d17b34b1a47b661945ca',
  SPORTS: 'cx08eb683a53d6f244d538a45f0cc584825e2cb985',
  TAP: 'cxc0b5b52c9f8b4251a47e91dda3bd61e5512cd782',
  WOK: 'cx921205acb7c51e16d5b7cbc37539a4357d929d20',
  ICX: 'cx0000000000000000000000000000000000000000',
};

export const SwapExchangesPanel = () => {
  const { marketInfo, tokenInfo } = useIconSwapService();
  const [hoverComponent, setHoverComponent] = useState<string>();
  const [marketInfoArray, setMarketInfoArray] = useState([]);
  const [isOpenSwapsModified, setIsOpenSwapsModified] = useState(false);
  const [isLastPriceModified, setIsLastPriceModified] = useState(false);
  const [openSwapsSort, setOpenSwapsSort] = useState<string>();
  const [lastPriceSort, setLastPriceSort] = useState<string>();

  useEffect(() => {
    getWindowDimensions();
    marketInfo &&
      marketInfo.map((token: any) => {
        const addToken = tokenToString(token.name);
        token.code = addToken;
        return token;
      });
    setMarketInfoArray(marketInfo);
  }, [marketInfo]);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };
  const { innerWidth: width } = window;

  const addData = (code: string, type: string) => {
    // @ts-ignore
    const token = swapTypes[code];
    // @ts-ignore
    return (
      tokenInfo &&
      tokenInfo.map((item: any) => {
        if (token === item.contract) {
          if (type === 'change' && item.change === 0) {
            return <ItemChange>-</ItemChange>;
          }
          if (type === 'change' && item.change > 0) {
            return (
              <PositiveItemChange>+{round(item.change, 2)}%</PositiveItemChange>
            );
          }
          if (type === 'change' && item.change < 0) {
            return (
              <NegativeItemChange>{round(item.change, 2)}%</NegativeItemChange>
            );
          }

          if (type === 'volume' && item.volume > 0) {
            return round(item.volume, 0);
          }
          return '-';
        }
      })
    );
  };

  const createTokensObject = () => {
    if (!marketInfoArray) {
      return;
    }
    return marketInfoArray.map((token: any) => {
      return hoverComponent === token.name && width > 414 ? (
        <Link
          to={`/swaps/${tokenToString(token.name)}`}
          style={{ textDecoration: 'none' }}
          key={token.name}
        >
          <ItemRowOnHover onMouseLeave={() => setHoverComponent('')}>
            <Icon src={renderIcon(token.name)} alt="token" />
            <ItemNameWrapper>
              <ItemName>{token.name}</ItemName>
              <ItemCode>{token.code}</ItemCode>
            </ItemNameWrapper>
            <ItemSwaps>
              {convertHexToDecimal(token.swaps_pending_count)}
            </ItemSwaps>
            <ItemPrice>
              {token.last_price ? round(token.last_price, 5) : '-'}
            </ItemPrice>
            {addData(token.code, 'change')}
            <ItemVolume>{addData(token.code, 'volume')}</ItemVolume>
          </ItemRowOnHover>
        </Link>
      ) : (
        <Link
          to={`/swaps/${tokenToString(token.name)}`}
          style={{ textDecoration: 'none' }}
          key={token.name}
        >
          <ItemRow
            key={token.name}
            onMouseEnter={() => setHoverComponent(token.name)}
          >
            <ResponsiveTopRow>
              <Icon src={renderIcon(token.name)} alt="token" />
              <ItemNameWrapper>
                <ItemName>{token.name}</ItemName>
                <ItemCode>{token.code}</ItemCode>
              </ItemNameWrapper>
            </ResponsiveTopRow>
            <ResponsiveLabel>
              <ItemSwaps>
                {convertHexToDecimal(token.swaps_pending_count)}
              </ItemSwaps>{' '}
              <ResponsiveText>Swaps</ResponsiveText>
            </ResponsiveLabel>
            <Divider></Divider>
            <ResponsiveLabel>
              <ItemPrice>
                {token.last_price ? round(token.last_price, 5) : '-'}
              </ItemPrice>
              <ResponsiveText>Last Price</ResponsiveText>
            </ResponsiveLabel>
            {addData(token.code, 'change')}
            <Divider></Divider>
            <ResponsiveLabel>
              <ItemVolume>{addData(token.code, 'volume')}</ItemVolume>
              <ResponsiveText>24h Volume</ResponsiveText>
            </ResponsiveLabel>
          </ItemRow>
        </Link>
      );
    });
  };

  const orderTokens = (columnName: string) => {
    if (columnName === 'openSwaps') {
      if (isOpenSwapsModified) {
        const reveresedArray = marketInfoArray.reverse();
        const newArr = [...reveresedArray];
        openSwapsSort === 'up'
          ? setOpenSwapsSort('down')
          : setOpenSwapsSort('up');
        return setMarketInfoArray(newArr);
      }
      const sortedArray = marketInfoArray.sort((a: any, b: any) =>
        a.swaps_pending_count > b.swaps_pending_count ? -1 : 1
      );
      const newArr = [...sortedArray];
      setIsOpenSwapsModified(true);
      setOpenSwapsSort('down');
      setLastPriceSort(undefined);
      return setMarketInfoArray(newArr);
    }
    if (columnName === 'lastPrice') {
      if (isLastPriceModified) {
        const reveresedArray = marketInfoArray.reverse();
        const newArr = [...reveresedArray];
        lastPriceSort === 'up'
          ? setLastPriceSort('down')
          : setLastPriceSort('up');
        return setMarketInfoArray(newArr);
      }
      const sortedArray = marketInfoArray.sort((a: any, b: any) =>
        a.last_price > b.last_price ? -1 : 1
      );
      const newArr = [...sortedArray];
      setLastPriceSort('down');
      setOpenSwapsSort(undefined);
      setIsLastPriceModified(true);
      return setMarketInfoArray(newArr);
    }
  };

  const tokenToString = (token: string) => {
    if (token === 'AC3') {
      return 'AC3';
    }
    if (token === 'SportsToken') {
      return 'SPORTS';
    }
    if (token === 'weBloc') {
      return 'WOK';
    }
    if (token === 'TapToken') {
      return 'TAP';
    }
    if (token === 'ICX') {
      return 'ICX';
    }
  };

  const renderSortArrow = (columnName: string) => {
    if (columnName === 'openSwaps') {
      switch (openSwapsSort) {
        case 'up':
          return SortedUp;
        case 'down':
          return SortedDown;
        default:
          return SortArrow;
      }
    }

    if (columnName === 'lastPrice') {
      switch (lastPriceSort) {
        case 'up':
          return SortedUp;
        case 'down':
          return SortedDown;
        default:
          return SortArrow;
      }
    }
  };

  return (
    <SwapExchangesPanelWrapper>
      <PanelHeader>Swap exchanges</PanelHeader>
      <TableHeader>
        <Name>Name</Name>
        <OpenSwaps>
          Open Swaps
          <SortArrowImage
            src={renderSortArrow('openSwaps')}
            alt="Sort arrow"
            onClick={() => {
              orderTokens('openSwaps');
            }}
          />
        </OpenSwaps>
        <LastPrice>
          Last Price
          <SortArrowImage
            src={renderSortArrow('lastPrice')}
            alt="Sort arrow"
            onClick={() => {
              orderTokens('lastPrice');
            }}
          />
        </LastPrice>
        <Change>24h Change</Change>
        <Volume>24h Volume</Volume>
      </TableHeader>
      {createTokensObject()}
      <BottomRow>
        <BottomRowText>All figures shown are paired to ICX</BottomRowText>
      </BottomRow>
    </SwapExchangesPanelWrapper>
  );
};

export default SwapExchangesPanel;

const SwapExchangesPanelWrapper = styled.div`
  width: 1055px;
  background-color: #fff;
  margin-bottom: 46px;
  box-shadow: 2px 2px 6px 2px #e9ebec;
  border-radius: 5px;
  border-color: #e9ebec;
  border-style: solid;
  border-width: 0.5px;
  @media (max-width: 414px) {
    width: 335px;
    margin-right: 0px;
    padding-left: 20px;
    padding-right: 27px;
  }
`;

const PanelHeader = styled.div`
  padding-top: 30px;
  margin-left: 30px;
  color: #0e0d0e;
  font-family: 'Avenir Next';
  font-size: 26px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 36px;
  @media (max-width: 414px) {
    font-size: 19px;
    height: 61px;
    margin-left: 0;
    padding-top: 15px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e9ebec;
  }
`;

const TableHeader = styled.div`
  display: flex;
  flex-direction: 'row';
  margin-top: 20px;
  padding-bottom: 19px;
  padding-left: 50px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #e9ebec;
  @media (max-width: 414px) {
    display: none;
  }
`;

const Icon = styled.img`
  height: 50px;
  width: 50px;
  margin-left: 20px;
  @media (max-width: 414px) {
    margin-left: auto;
    height: 45px;
    width: 45px;
  }
`;

const Name = styled.div`
  font-family: 'Avenir Next';
  font-size: 15px;
`;

const OpenSwaps = styled.div`
  margin-left: 250px;
  font-family: 'Avenir Next';
  font-size: 15px;
`;

const LastPrice = styled.div`
  margin-left: 110px;
  font-family: 'Avenir Next';
  font-size: 15px;
`;

const Change = styled.div`
  margin-left: 90px;
  font-family: 'Avenir Next';
  font-size: 15px;
`;

const Volume = styled.div`
  margin-left: 100px;
  font-family: 'Avenir Next';
  font-size: 15px;
`;

const ItemRow = styled.div`
  height: 88px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #e9ebec;
  margin-left: 30px;
  margin-right: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 414px) {
    flex-wrap: wrap;
    justify-content: space-between;
    height: 150px;
    width: 300px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 10px;
    padding-bottom: 15px;
  }
`;

const ItemRowOnHover = styled.div`
  height: 88px;
  border-width: 1px;
  border-style: solid;
  border-color: #e9ebec;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 2px 2px 6px 2px #e9ebec;
  border-radius: 5px;
`;

const ItemNameWrapper = styled.div`
  width: 219px;
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  @media (max-width: 414px) {
    margin-left: 10px;
    width: 163px;
    flex-wrap: wrap;
  }
`;

const ItemName = styled.div`
  color: #000;
  font-family: 'Avenir Next Demi Bold';
  font-size: 15px;
  @media (max-width: 414px) {
    height: 20px;
    margin-right: 10px;
  }
`;

const ItemCode = styled.div`
  font-family: 'Avenir Next';
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  color: rgba(9, 8, 9, 0.5);
  @media (max-width: 414px) {
    margin-left: 0px;
  }
`;

const ItemSwaps = styled.div`
  width: 166px;
  padding-left: 5px;
  color: #000;
  font-family: 'Avenir Next Medium';
  @media (max-width: 414px) {
    width: 50px;
    padding-left: 0px;
    font-weight: bold;
  }
`;

const ItemPrice = styled.div`
  width: 131px;
  text-align: right;
  color: #000;
  font-family: 'Avenir Next Medium';
  @media (max-width: 414px) {
    width: 50px;
    text-align: left;
    margin-left: 0;
    font-weight: bold;
  }
}
`;

const ItemChange = styled.div`
  width: 178px;
  text-align: right;
  color: #000;
  font-family: 'Avenir Next Medium';
  @media (max-width: 414px) {
    width: 50px;
    order: 1;
    font-size: 13px;
  }
`;

const PositiveItemChange = styled.div`
  width: 178px;
  text-align: right;
  color: #4fb83b;
  font-family: 'Avenir Next Medium';
  @media (max-width: 414px) {
    width: 50px;
    order: 1;
    font-size: 13px;
  }
`;

const NegativeItemChange = styled.div`
  width: 178px;
  text-align: right;
  font-family: 'Avenir Next Medium';
  color: #de3617;
  @media (max-width: 414px) {
    width: 50px;
    order: 1;
    font-size: 13px;
  }
`;

const ItemVolume = styled.div`
  width: 185px;
  text-align: right;
  color: #000;
  font-family: 'Avenir Next Medium';
  @media (max-width: 414px) {
    width: 50px;
    text-align: left;
    margin-left: 0;
    font-weight: bold;
  }
`;

const BottomRow = styled.div`
  display: flex;
  height: 81px;
  justify-content: center;
  align-items: center;
  @media (max-width: 414px) {
    height: 61px;
  }
`;

const BottomRowText = styled.div`
  color: rgba(9, 8, 9, 0.4);
  font-family: 'Avenir Next';
  font-size: 13px;
  letter-spacing: 0;
  @media (max-width: 414px) {
    color: rgba(0, 0, 0, 0.4);
    font-family: 'Avenir Next';
    font-size: 13px;
  }
`;

const SortArrowImage = styled.img`
  height: 12px;
  width: 8px;
  object-fit: contain;
  margin-left: 5px;
`;

const ResponsiveTopRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ResponsiveLabel = styled.div`
  @media (max-width: 414px) {
    order: 2;
    font-size: 13px;
    text-align: left;
  }
`;

const ResponsiveText = styled.div`
  display: none;
  @media (max-width: 414px) {
    display: initial;
    color: #000;
  }
`;

const Divider = styled.div`
  @media (max-width: 414px) {
    order: 2;
    height: 15px;
    width: 10px;
    margin: 0 auto;
    color: #d3d7e0;
  }
`;
